import {
  SidebarNavigationContainer,
  SidebarNavigationItem,
} from "@king-ict/eupisi-ui/components";
import { useTranslation } from "react-i18next";
import { useLocation, useRouteMatch } from "react-router";

import { useAuth } from "../../hooks";
import { Role } from "../../models/Shared/Role";
import {
  institutionListRoute,
  institutionDetailsRoute,
  dashboardRoute,
  schoolYearListRoute,
  schoolCandidateRoute,
  schoolCandidateAddressAccessRoute,
  institutionEditRoute,
  houseNumberInstitutionListRoute,
  schoolCandidateDetailRoute,
  schoolCandidateEditRoute,
  schoolCandidateInstitutionSummaryListRoute,
  schoolCandidateInstitutionListRoute,
  schoolCandidateInstitutionReassignmentRoute,
  schoolCandidateInstitutionAdminListRoute,
  schoolCandidateInstitutionAdminDetailRoute,
  schoolCandidateInstitutionAdminEditRoute,
  announcementListRoute,
  faqGroupListRoute,
  faqItemListRoute,
  announcementEditRoute,
  announcementDetailRoute,
  faqGroupDetailRoute,
  faqGroupEditRoute,
  faqItemDetailRoute,
  faqItemEditRoute,
  editImportantDateRoute,
  committeeListRoute,
  committeeEditRoute,
  committeeDetailRoute,
  committeeApprovalListRoute,
  committeeApprovalDetailRoute,
  committeeApprovalEditRoute,
  countyCommitteeListRoute,
  countyCommitteeDetailRoute,
  countyCommitteeEditRoute,
  ministryCommitteeListRoute,
  ministryCommitteeDetailRoute,
  ministryCommitteeEditRoute,
  regionalCommitteeListRoute,
  regionalCommitteeEditRoute,
  userRoleRoute,
  roleListRoute,
  userDetailRoute,
  userEditRoute,
  userListUrl,
  requestListRoute,
  requestCreateRoute,
  requestEditRoute,
  requestDetailsRoute,
  requestInstitutionEditRoute,
  requestAdminRoute,
  requestAdminListRoute,
  requestAdminDetailsRoute,
  requestAdminSchoolCandidateCreateRoute,
  outsideEnrollmentAreaListRoute,
  outsideEnrollmentAreaEditRoute,
  languageCourseDecisionListRoute,
  languageCourseDecisionEditRoute,
  medicalExaminationEditRoute,
  mzomAppealEditRoute,
  enrollmentInstitutionEditRoute,
  languageCourseDecisionMinistryListRoute,
  languageCourseDecisionMinistryEditRoute,
  committeeDecisionDetailsRoute,
  committeeDecisionEditRoute,
  decisionProposalEditRoute,
  form6EditRoute,
  form7EditRoute,
  enrollmentDecisionEditRoute,
  registrationFormListRoute,
  registrationFormEditRoute,
  registeredListRoute,
  faqGroupsAndItemsRoute,
  aboutProgramRoute,
  helpAndSupportRoute,
  newErrorReporRoute,
  statementOfAccessibilityRoute,
  privacyStatementRoute,
  departmentListRoute,
  requestDepartmentProgramListRoute,
  schoolCandidateDepartmentScheduleRoute,
  SCHOOL_CANDIDATE_ROUTES,
} from "../../routes/routes";
import { enrollmentFormEditRoute } from "../../routes/routes";
import AboutProgram from "../AboutProgram/AboutProgram";
import {
  AnnouncementDetails,
  AnnouncementEdit,
  AnnouncementList,
} from "../Announcement";
import {
  CommitteeList,
  CommitteeEdit,
  CommitteeDetails,
  CommitteeApprovalList,
  CommitteeApprovalDetails,
  CommitteeApprovalEdit,
  CountyCommitteeList,
  CountyCommitteeDetails,
  CountyCommitteeEdit,
  MinistryCommitteeList,
  MinistryCommitteeDetails,
  MinistryCommitteeEdit,
  RegionalCommitteeList,
  RegionalCommitteeEdit,
} from "../Committee";
import { Dashboard } from "../Dashboard";
import { RequestDepartmentProgramList } from "../Departments";
import { DepartmentList } from "../Departments/DepartmentList";
import { SchoolCandidateDepartmentSchedule } from "../Departments/SchoolCandidateDepartmentSchedule";
import { ErrorReportCreate } from "../ErrorReport/ErrorReportCreate";
import {
  Faq,
  FaqGroupDetails,
  FaqGroupEdit,
  FaqGroupList,
  FaqItemDetails,
  FaqItemEdit,
  FaqItemList,
} from "../Faq";
import HelpAndSupport from "../HelpAndSupport/HelpAndSupport";
import { HouseNumberInstitutionList } from "../HouseNumberInstitution";
import { InstitutionList } from "../Institutions";
import { InstitutionDetails } from "../Institutions/InstitutionDetails";
import { InstitutionEdit } from "../Institutions/InstitutionEdit";
import {
  RequestList,
  RequestCreate,
  RequestEdit,
  RequestInstitutionEdit,
  RequestAdminList,
  RequestDetails,
  RequestSchoolCandidateCreate,
  OutsideEnrollmentAreaList,
  OutsideEnrollmentAreaEdit,
  LanguageCourseDecisionList,
  LanguageCourseDecisionEdit,
  LanguageCourseDecisionMinistryList,
  MedicalExaminationEdit,
  MzomAppealEdit,
  CommitteeDecisionDetails,
  CommitteeDecisionEdit,
  DecisionProposalEdit,
  Form7Edit,
  EnrollmentDecisionEdit,
  RegistrationFormList,
  RegistrationFormEdit,
  RegistrationList,
  EnrollmentInstitutionEdit,
  Form6Edit,
} from "../Request";
import {
  SchoolCandidateDetails,
  SchoolCandidateEdit,
  SchoolCandidateList,
  SchoolCandidateInstitutionSummaryList,
  SchoolCandidateInstitutionList,
  SchoolCandidateInstitutionReassignment,
  SchoolCandidateInstitutionAdminList,
} from "../SchoolCandidate";
import { SchoolCandidateAddressAccess } from "../SchoolCandidate/SchoolCandidateAddressAccess";
import { SchoolNotePage } from "../SchoolCandidate/pages/SchoolNotePage";
import { ImportantDateList, SchoolYearList } from "../SchoolYear";
import { StatementOfAccessibility } from "../StatementOfAccessibility";
import { PrivacyStatement } from "../PrivacyStatement";
import { RoleList, UserList, UserDetails, UserEdit } from "../User";
import {
  INSTITUTION_ACCESS,
  ADMINISTRATION_ACCESS,
  COMMITTEE_ACCESS,
  REQUEST_ADMIN_BLACKLIST,
  SCHOOL_CANDIDATE_ACCESS,
} from "./constants";
import { EditEnrollmentForm } from "../Request/EnrollmentForm/EditEnrollmentForm";

export interface MatchParams {
  requestId: string;
  id: string;
}
export interface SidebarProps {
  sidebarIsOpen?: boolean;
}

export function Sidebar({ sidebarIsOpen }: SidebarProps) {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const auth = useAuth();
  const { hasRoleAccess } = auth;

  const errorReportMatch = useRouteMatch<MatchParams>(newErrorReporRoute);

  const importantDateEditMatch = useRouteMatch<MatchParams>(
    editImportantDateRoute
  );

  const schoolCandidatedDetailsMatch = useRouteMatch<MatchParams>(
    schoolCandidateDetailRoute
  );
  const schoolCandidatedEditMatch = useRouteMatch<MatchParams>(
    schoolCandidateEditRoute
  );
  const schoolCandidateInstitutionListMatch = useRouteMatch<MatchParams>(
    schoolCandidateInstitutionListRoute
  );
  const schoolCandidateInstitutionReassignmentMatch =
    useRouteMatch<MatchParams>(schoolCandidateInstitutionReassignmentRoute);
  const schoolCandidateInstitutionAdminDetailsMatch =
    useRouteMatch<MatchParams>(schoolCandidateInstitutionAdminDetailRoute);
  const schoolCandidateInstitutionAdminEditMatch = useRouteMatch<MatchParams>(
    schoolCandidateInstitutionAdminEditRoute
  );
  const schoolCandidateNotesMatch = useRouteMatch<MatchParams>(
    SCHOOL_CANDIDATE_ROUTES.notes
  );
  const schoolCandidateInstitutionAdminNotesMatch = useRouteMatch<MatchParams>(
    SCHOOL_CANDIDATE_ROUTES.institutionAdminNotes
  );
  const schoolCandidateAddressAccessMatch = useRouteMatch<MatchParams>(
    schoolCandidateAddressAccessRoute
  );

  const institutionDetailsMatch = useRouteMatch<MatchParams>(
    institutionDetailsRoute
  );
  const institutionEditMatch = useRouteMatch<MatchParams>(institutionEditRoute);

  const announcementDetailMatch = useRouteMatch<MatchParams>(
    announcementDetailRoute
  );
  const announcementEditMatch = useRouteMatch<MatchParams>(
    announcementEditRoute
  );

  const faqGroupDetailMatch = useRouteMatch<MatchParams>(faqGroupDetailRoute);
  const faqGroupEditMatch = useRouteMatch<MatchParams>(faqGroupEditRoute);

  const faqItemDetailMatch = useRouteMatch<MatchParams>(faqItemDetailRoute);
  const faqItemEditMatch = useRouteMatch<MatchParams>(faqItemEditRoute);

  const committeeDetailMatch = useRouteMatch<MatchParams>(committeeDetailRoute);
  const committeeEditMatch = useRouteMatch<MatchParams>(committeeEditRoute);
  const committeeApprovalDetailsMatch = useRouteMatch<MatchParams>(
    committeeApprovalDetailRoute
  );
  const committeeApprovalEditMatch = useRouteMatch<MatchParams>(
    committeeApprovalEditRoute
  );
  const countyCommitteeDetailsMatch = useRouteMatch<MatchParams>(
    countyCommitteeDetailRoute
  );
  const countyCommitteeEditMatch = useRouteMatch<MatchParams>(
    countyCommitteeEditRoute
  );
  const ministryCommitteeDetailsMatch = useRouteMatch<MatchParams>(
    ministryCommitteeDetailRoute
  );
  const ministryCommitteeEditMatch = useRouteMatch<MatchParams>(
    ministryCommitteeEditRoute
  );
  const regionalCommitteeEditMatch = useRouteMatch<MatchParams>(
    regionalCommitteeEditRoute
  );

  const roleListMatch = useRouteMatch<MatchParams>(roleListRoute);
  const userDetailsMatch = useRouteMatch<MatchParams>(userDetailRoute);
  const userEditMatch = useRouteMatch<MatchParams>(userEditRoute);

  const requestCreateMatch = useRouteMatch<MatchParams>(requestCreateRoute);
  const requestEditMatch = useRouteMatch<MatchParams>(requestEditRoute);
  const requestDetailsMatch = useRouteMatch<MatchParams>(requestDetailsRoute);
  const requestInstitutionEditMatch = useRouteMatch<MatchParams>(
    requestInstitutionEditRoute
  );
  const requestAdminDetailsMatch = useRouteMatch<MatchParams>(
    requestAdminDetailsRoute
  );
  const requestAdminSchoolCandidateCreateMatch = useRouteMatch<MatchParams>(
    requestAdminSchoolCandidateCreateRoute
  );
  const committeeDecisionDetailsMatch = useRouteMatch<MatchParams>(
    committeeDecisionDetailsRoute
  );
  const committeeDecisionEditMatch = useRouteMatch<MatchParams>(
    committeeDecisionEditRoute
  );
  const decisionProposalEditMatch = useRouteMatch<MatchParams>(
    decisionProposalEditRoute
  );
  const form6EditMatch = useRouteMatch<MatchParams>(form6EditRoute);
  const form7EditMatch = useRouteMatch<MatchParams>(form7EditRoute);
  const medicalExaminationEditMatch = useRouteMatch<MatchParams>(
    medicalExaminationEditRoute
  );
  const mzomAppealEditMatch = useRouteMatch<MatchParams>(mzomAppealEditRoute);
  const enrollmentDecisionEditMatch = useRouteMatch<MatchParams>(
    enrollmentDecisionEditRoute
  );
  const enrollmentInstitutionEditMatch = useRouteMatch<MatchParams>(
    enrollmentInstitutionEditRoute
  );
  const outsideEnrollmentAreaEditMatch = useRouteMatch<MatchParams>(
    outsideEnrollmentAreaEditRoute
  );
  const languageCourseDecisionEditMatch = useRouteMatch<MatchParams>(
    languageCourseDecisionEditRoute
  );
  const languageCourseDecisionMinistryEditMatch = useRouteMatch<MatchParams>(
    languageCourseDecisionMinistryEditRoute
  );
  const registrationFormEditMatch = useRouteMatch<MatchParams>(
    registrationFormEditRoute
  );
  const enrollmentFormEditMatch = useRouteMatch<MatchParams>(
    enrollmentFormEditRoute
  );

  const getAdministrationItems = () => {
    let annouuncementRoute = "";
    let faqGroupRoute = "";
    let faqItemRoute = "";
    let annouuncementUrl = undefined;
    let faqGroupUrl = undefined;
    let faqItemUrl = undefined;
    let annouuncementRouteComponent = <></>;
    let faqGroupRouteComponent = <></>;
    let faqItemRouteComponent = <></>;

    if (announcementDetailMatch?.isExact) {
      annouuncementRoute = announcementDetailRoute;
      annouuncementUrl = announcementDetailMatch.url;
      annouuncementRouteComponent = <AnnouncementDetails />;
    } else if (announcementEditMatch?.isExact) {
      annouuncementRoute = announcementEditRoute;
      annouuncementUrl = announcementEditMatch.url;
      annouuncementRouteComponent = <AnnouncementEdit />;
    } else {
      annouuncementRoute = announcementListRoute;
      annouuncementRouteComponent = <AnnouncementList />;
    }

    if (faqGroupDetailMatch?.isExact) {
      faqGroupRoute = faqGroupDetailRoute;
      faqGroupUrl = faqGroupDetailMatch.url;
      faqGroupRouteComponent = <FaqGroupDetails />;
    } else if (faqGroupEditMatch?.isExact) {
      faqGroupRoute = faqGroupEditRoute;
      faqGroupUrl = faqGroupEditMatch.url;
      faqGroupRouteComponent = <FaqGroupEdit />;
    } else {
      faqGroupRoute = faqGroupListRoute;
      faqGroupRouteComponent = <FaqGroupList />;
    }

    if (faqItemDetailMatch?.isExact) {
      faqItemRoute = faqItemDetailRoute;
      faqItemUrl = faqItemDetailMatch.url;
      faqItemRouteComponent = <FaqItemDetails />;
    } else if (faqItemEditMatch?.isExact) {
      faqItemRoute = faqItemEditRoute;
      faqItemUrl = faqItemEditMatch.url;
      faqItemRouteComponent = <FaqItemEdit />;
    } else {
      faqItemRoute = faqItemListRoute;
      faqItemRouteComponent = <FaqItemList />;
    }

    return [
      <SidebarNavigationItem
        key="1"
        name={t("sidebar.announcementList")}
        route={annouuncementRoute}
        url={annouuncementUrl}
      >
        {annouuncementRouteComponent}
      </SidebarNavigationItem>,
      <SidebarNavigationItem
        key="2"
        name={t("sidebar.faqGroupList")}
        route={faqGroupRoute}
        url={faqGroupUrl}
      >
        {faqGroupRouteComponent}
      </SidebarNavigationItem>,
      <SidebarNavigationItem
        key="3"
        name={t("sidebar.faqItemList")}
        route={faqItemRoute}
        url={faqItemUrl}
      >
        {faqItemRouteComponent}
      </SidebarNavigationItem>,
    ];
  };

  const getImportantDatesItems = () => {
    let route = "";
    let url = undefined;
    let routeComponent = <></>;

    if (importantDateEditMatch?.isExact) {
      route = editImportantDateRoute;
      url = importantDateEditMatch.url;
      routeComponent = <ImportantDateList />;
    } else {
      route = schoolYearListRoute;
      routeComponent = <SchoolYearList />;
    }

    return (
      <SidebarNavigationItem
        key="4"
        name={t("sidebar.importantDates")}
        route={route}
        url={url}
      >
        {routeComponent}
      </SidebarNavigationItem>
    );
  };
  const getInstitutionItems = () => {
    let route = "";
    let url = undefined;
    let routeComponent = <></>;

    if (institutionDetailsMatch?.isExact) {
      route = institutionDetailsRoute;
      url = institutionDetailsMatch.url;
      routeComponent = <InstitutionDetails />;
    } else if (institutionEditMatch?.isExact) {
      route = institutionEditRoute;
      url = institutionEditMatch.url;
      routeComponent = <InstitutionEdit />;
    } else {
      route = institutionListRoute;
      routeComponent = <InstitutionList />;
    }

    return (
      <SidebarNavigationItem
        key="5"
        name={t("sidebar.institutionList")}
        route={route}
        url={url}
      >
        {routeComponent}
      </SidebarNavigationItem>
    );
  };
  const getHouseNumberInstitutionItems = () => {
    let route = "";
    let url = undefined;
    let routeComponent = <></>;

    route = houseNumberInstitutionListRoute;
    routeComponent = <HouseNumberInstitutionList />;

    return (
      <SidebarNavigationItem
        key="6"
        name={t("sidebar.houseNumberInstitutionList")}
        route={route}
        url={url}
      >
        {routeComponent}
      </SidebarNavigationItem>
    );
  };
  const getSchoolCandidateItems = () => {
    let route = "";
    let url = undefined;
    let routeComponent = <></>;

    if (schoolCandidatedDetailsMatch?.isExact) {
      route = schoolCandidateDetailRoute;
      url = schoolCandidatedDetailsMatch.url;
      routeComponent = <SchoolCandidateDetails />;
    } else if (schoolCandidateNotesMatch?.isExact) {
      route = SCHOOL_CANDIDATE_ROUTES.notes;
      url = schoolCandidateNotesMatch.url;
      routeComponent = <SchoolNotePage />;
    } else if (schoolCandidatedEditMatch?.isExact) {
      route = schoolCandidateEditRoute;
      url = schoolCandidatedEditMatch.url;
      routeComponent = <SchoolCandidateEdit />;
    } else if (schoolCandidateInstitutionReassignmentMatch?.isExact) {
      route = schoolCandidateInstitutionReassignmentRoute;
      url = schoolCandidateInstitutionReassignmentMatch.url;
      routeComponent = <SchoolCandidateInstitutionReassignment />;
    } else {
      route = schoolCandidateRoute;
      routeComponent = <SchoolCandidateList />;
    }

    return (
      <SidebarNavigationItem
        key="7"
        name={t("sidebar.schoolCandidateUOList")}
        route={route}
        url={url}
      >
        {routeComponent}
      </SidebarNavigationItem>
    );
  };
  const getSchoolCandidateAddressAccessItems = () => {
    let route = "";
    let url = undefined;
    let routeComponent = <></>;

    if (schoolCandidateAddressAccessMatch?.isExact) {
      route = schoolCandidateAddressAccessRoute;
      url = schoolCandidateAddressAccessMatch.url;
      routeComponent = <SchoolCandidateAddressAccess />;
    } else {
      route = schoolCandidateAddressAccessRoute;
      routeComponent = <SchoolCandidateAddressAccess />;
    }

    return (
      <SidebarNavigationItem
        key="7-1"
        name={t("sidebar.schoolCandidateAddressAccessList")}
        route={route}
        url={url}
      >
        {routeComponent}
      </SidebarNavigationItem>
    );
  };
  const getSchoolCandidateInstitutionSummaryItems = () => {
    let route = "";
    let url = undefined;
    let routeComponent = <></>;

    if (schoolCandidateInstitutionListMatch?.isExact) {
      route = schoolCandidateInstitutionListRoute;
      url = schoolCandidateInstitutionListMatch.url;
      routeComponent = <SchoolCandidateInstitutionList />;
    } else if (schoolCandidateInstitutionAdminNotesMatch?.isExact) {
      route = SCHOOL_CANDIDATE_ROUTES.institutionAdminNotes;
      // There is no need to se the url or routeComponent
      // because of the way it gets added in the getSchoolCandidateInstitutionList function
      // It is duplicated otherwise...
    } else {
      route = schoolCandidateInstitutionSummaryListRoute;
      routeComponent = <SchoolCandidateInstitutionSummaryList />;
    }

    return (
      <SidebarNavigationItem
        key="8"
        name={t("sidebar.schoolCandidateInstitutionSummary")}
        route={route}
        url={url}
      >
        {routeComponent}
      </SidebarNavigationItem>
    );
  };

  const getSchoolCandidateInstitutionList = () => {
    let route = "";
    let url = undefined;
    let routeComponent = <></>;

    if (schoolCandidateInstitutionAdminDetailsMatch?.isExact) {
      route = schoolCandidateInstitutionAdminDetailRoute;
      url = schoolCandidateInstitutionAdminDetailsMatch.url;
      routeComponent = <SchoolCandidateDetails />;
    } else if (schoolCandidateInstitutionAdminEditMatch?.isExact) {
      route = schoolCandidateInstitutionAdminEditRoute;
      url = schoolCandidateInstitutionAdminEditMatch.url;
      routeComponent = <SchoolCandidateEdit />;
    } else if (schoolCandidateInstitutionAdminNotesMatch?.isExact) {
      route = SCHOOL_CANDIDATE_ROUTES.institutionAdminNotes;
      url = schoolCandidateInstitutionAdminNotesMatch.url;
      routeComponent = <SchoolNotePage />;
    } else {
      route = schoolCandidateInstitutionAdminListRoute;
      routeComponent = <SchoolCandidateInstitutionAdminList />;
    }

    return (
      <SidebarNavigationItem
        key="23"
        name={t("sidebar.schoolCandidateInstitutionAdminList")}
        route={route}
        url={url}
      >
        {routeComponent}
      </SidebarNavigationItem>
    );
  };
  const getCommitteeItems = () => {
    let route = "";
    let url = undefined;
    let routeComponent = <></>;

    if (committeeEditMatch?.isExact) {
      route = committeeEditRoute;
      url = committeeEditMatch.url;
      routeComponent = <CommitteeEdit />;
    } else if (committeeDetailMatch?.isExact) {
      route = committeeDetailRoute;
      url = committeeDetailMatch.url;
      routeComponent = <CommitteeDetails />;
    } else {
      route = committeeListRoute;
      routeComponent = <CommitteeList />;
    }

    return (
      <SidebarNavigationItem
        key="9"
        name={t("sidebar.committeeInstitution")}
        route={route}
        url={url}
      >
        {routeComponent}
      </SidebarNavigationItem>
    );
  };
  const getCommitteeApprovalItems = () => {
    let route = "";
    let url = undefined;
    let routeComponent = <></>;

    if (committeeApprovalEditMatch?.isExact) {
      route = committeeApprovalEditRoute;
      url = committeeApprovalEditMatch.url;
      routeComponent = <CommitteeApprovalEdit />;
    } else if (committeeApprovalDetailsMatch?.isExact) {
      route = committeeApprovalDetailRoute;
      url = committeeApprovalDetailsMatch.url;
      routeComponent = <CommitteeApprovalDetails />;
    } else {
      route = committeeApprovalListRoute;
      routeComponent = <CommitteeApprovalList />;
    }

    return (
      <SidebarNavigationItem
        key="10"
        name={t("sidebar.committeeApprovalList")}
        route={route}
        url={url}
      >
        {routeComponent}
      </SidebarNavigationItem>
    );
  };
  const getCountyCommitteeItems = () => {
    let route = "";
    let url = undefined;
    let routeComponent = <></>;

    if (countyCommitteeEditMatch?.isExact) {
      route = countyCommitteeEditRoute;
      url = countyCommitteeEditMatch.url;
      routeComponent = <CountyCommitteeEdit />;
    } else if (countyCommitteeDetailsMatch?.isExact) {
      route = countyCommitteeDetailRoute;
      url = countyCommitteeDetailsMatch.url;
      routeComponent = <CountyCommitteeDetails />;
    } else {
      route = countyCommitteeListRoute;
      routeComponent = <CountyCommitteeList />;
    }

    return (
      <SidebarNavigationItem
        key="11"
        name={t("sidebar.countyCommitteeList")}
        route={route}
        url={url}
      >
        {routeComponent}
      </SidebarNavigationItem>
    );
  };
  const getMinistryCommitteeItems = () => {
    let route = "";
    let url = undefined;
    let routeComponent = <></>;

    if (ministryCommitteeEditMatch?.isExact) {
      route = ministryCommitteeEditRoute;
      url = ministryCommitteeEditMatch.url;
      routeComponent = <MinistryCommitteeEdit />;
    } else if (ministryCommitteeDetailsMatch?.isExact) {
      route = ministryCommitteeDetailRoute;
      url = ministryCommitteeDetailsMatch.url;
      routeComponent = <MinistryCommitteeDetails />;
    } else {
      route = ministryCommitteeListRoute;
      routeComponent = <MinistryCommitteeList />;
    }

    return (
      <SidebarNavigationItem
        key="12"
        name={t("sidebar.ministryCommitteeList")}
        route={route}
        url={url}
      >
        {routeComponent}
      </SidebarNavigationItem>
    );
  };
  const getRegionalCommitteeItems = () => {
    let route = "";
    let url = undefined;
    let routeComponent = <></>;

    if (regionalCommitteeEditMatch?.isExact) {
      route = regionalCommitteeEditRoute;
      url = regionalCommitteeEditMatch.url;
      routeComponent = <RegionalCommitteeEdit />;
    } else {
      route = regionalCommitteeListRoute;
      routeComponent = <RegionalCommitteeList />;
    }

    return (
      <SidebarNavigationItem
        key="96"
        name={t("sidebar.regionalCommitteeList")}
        route={route}
        url={url}
      >
        {routeComponent}
      </SidebarNavigationItem>
    );
  };
  const getUsersRolesItems = () => {
    let route = "";
    let url = undefined;
    let routeComponent = <></>;

    if (userEditMatch?.isExact) {
      route = userEditRoute;
      url = userEditMatch.url;
      routeComponent = <UserEdit />;
    } else if (userDetailsMatch?.isExact) {
      route = userDetailRoute;
      url = userDetailsMatch.url;
      routeComponent = <UserDetails />;
    } else {
      route = userListUrl();
      routeComponent = <UserList />;
    }

    return (
      <SidebarNavigationItem
        key="13"
        name={t("sidebar.users")}
        route={route}
        url={url}
      >
        {routeComponent}
      </SidebarNavigationItem>
    );
  };
  const getRequestItems = () => {
    let route = "";
    let url = undefined;
    let routeComponent = <></>;

    if (requestCreateMatch?.isExact) {
      route = requestCreateRoute;
      url = requestCreateMatch.url;
      routeComponent = <RequestCreate />;
    } else if (requestEditMatch?.isExact) {
      route = requestEditRoute;
      url = requestEditMatch.url;
      routeComponent = <RequestEdit />;
    } else if (requestDetailsMatch?.isExact) {
      route = requestDetailsRoute;
      url = requestDetailsMatch.url;
      routeComponent = <RequestDetails />;
    } else {
      route = requestListRoute;
      routeComponent = <RequestList />;
    }

    return (
      <SidebarNavigationItem
        key="14"
        name={t("sidebar.requestListItems")}
        route={route}
        url={url}
      >
        {routeComponent}
      </SidebarNavigationItem>
    );
  };
  const getRequestAdminItems = () => {
    let route = "";
    let url = undefined;
    let routeComponent = <></>;

    if (requestAdminDetailsMatch?.isExact) {
      route = requestAdminDetailsRoute;
      url = requestAdminDetailsMatch.url;
      routeComponent = <RequestDetails />;
    } else if (requestAdminSchoolCandidateCreateMatch?.isExact) {
      route = requestAdminSchoolCandidateCreateRoute;
      url = requestAdminSchoolCandidateCreateMatch.url;
      routeComponent = <RequestSchoolCandidateCreate />;
    } else if (requestInstitutionEditMatch?.isExact) {
      route = requestInstitutionEditRoute;
      url = requestInstitutionEditMatch.url;
      routeComponent = <RequestInstitutionEdit />;
    } else if (committeeDecisionEditMatch?.isExact) {
      route = committeeDecisionEditRoute;
      url = committeeDecisionEditMatch.url;
      routeComponent = <CommitteeDecisionEdit />;
    } else if (committeeDecisionDetailsMatch?.isExact) {
      route = committeeDecisionDetailsRoute;
      url = committeeDecisionDetailsMatch.url;
      routeComponent = <CommitteeDecisionDetails />;
    } else if (decisionProposalEditMatch?.isExact) {
      route = decisionProposalEditRoute;
      url = decisionProposalEditMatch.url;
      routeComponent = <DecisionProposalEdit />;
    } else if (form7EditMatch?.isExact) {
      route = form7EditRoute;
      url = form7EditMatch.url;
      routeComponent = <Form7Edit />;
    } else if (form6EditMatch?.isExact) {
      route = form6EditRoute;
      url = form6EditMatch.url;
      routeComponent = <Form6Edit />;
    } else if (enrollmentDecisionEditMatch?.isExact) {
      route = enrollmentDecisionEditRoute;
      url = enrollmentDecisionEditMatch.url;
      routeComponent = <EnrollmentDecisionEdit />;
    } else if (enrollmentInstitutionEditMatch?.isExact) {
      route = enrollmentInstitutionEditRoute;
      url = enrollmentInstitutionEditMatch.url;
      routeComponent = <EnrollmentInstitutionEdit />;
    } else if (medicalExaminationEditMatch?.isExact) {
      route = medicalExaminationEditRoute;
      url = medicalExaminationEditMatch.url;
      routeComponent = <MedicalExaminationEdit />;
    } else if (mzomAppealEditMatch?.isExact) {
      route = mzomAppealEditRoute;
      url = mzomAppealEditMatch.url;
      routeComponent = <MzomAppealEdit />;
    } else if (enrollmentFormEditMatch?.isExact) {
      route = enrollmentFormEditRoute;
      url = enrollmentFormEditMatch.url;
      routeComponent = <EditEnrollmentForm />;
    } else {
      route = requestAdminListRoute;
      routeComponent = <RequestAdminList />;
    }

    return (
      <SidebarNavigationItem
        key="91"
        name={t("sidebar.requestAdminList")}
        route={route}
        url={url}
      >
        {routeComponent}
      </SidebarNavigationItem>
    );
  };
  const getOutsideEnrollmentAreaItems = () => {
    let route = "";
    let url = undefined;
    let routeComponent = <></>;

    if (outsideEnrollmentAreaEditMatch?.isExact) {
      route = outsideEnrollmentAreaEditRoute;
      url = outsideEnrollmentAreaEditMatch.url;
      routeComponent = <OutsideEnrollmentAreaEdit />;
    } else {
      route = outsideEnrollmentAreaListRoute;
      routeComponent = <OutsideEnrollmentAreaList />;
    }

    return (
      <SidebarNavigationItem
        key="92"
        name={t("sidebar.outsideEnrollmentAreaList")}
        route={route}
        url={url}
      >
        {routeComponent}
      </SidebarNavigationItem>
    );
  };
  const getLanguageCourseDecisionItems = () => {
    let route = "";
    let url = undefined;
    let routeComponent = <></>;

    if (languageCourseDecisionEditMatch?.isExact) {
      route = languageCourseDecisionEditRoute;
      url = languageCourseDecisionEditMatch.url;
      routeComponent = <LanguageCourseDecisionEdit />;
    } else {
      route = languageCourseDecisionListRoute;
      routeComponent = <LanguageCourseDecisionList />;
    }

    return (
      <SidebarNavigationItem
        key="93"
        name={t("sidebar.languageCourseDecisionList")}
        route={route}
        url={url}
      >
        {routeComponent}
      </SidebarNavigationItem>
    );
  };
  const getLanguageCourseDecisionMinistryItems = () => {
    let route = "";
    let url = undefined;
    let routeComponent = <></>;

    if (languageCourseDecisionMinistryEditMatch?.isExact) {
      route = languageCourseDecisionMinistryEditRoute;
      url = languageCourseDecisionMinistryEditMatch.url;
      routeComponent = <LanguageCourseDecisionEdit />;
    } else {
      route = languageCourseDecisionMinistryListRoute;
      routeComponent = <LanguageCourseDecisionMinistryList />;
    }

    return (
      <SidebarNavigationItem
        key="96"
        name={t("sidebar.languageCourseDecisionMinistryList")}
        route={route}
        url={url}
      >
        {routeComponent}
      </SidebarNavigationItem>
    );
  };
  const getRegistrationFormItems = () => {
    let route = "";
    let url = undefined;
    let routeComponent = <></>;

    if (registrationFormEditMatch?.isExact) {
      route = registrationFormEditRoute;
      url = registrationFormEditMatch.url;
      routeComponent = <RegistrationFormEdit />;
    } else {
      route = registrationFormListRoute;
      routeComponent = <RegistrationFormList />;
    }

    return (
      <SidebarNavigationItem
        key="94"
        name={t("sidebar.enrolledSchoolCandidateList")}
        route={route}
        url={url}
      >
        {routeComponent}
      </SidebarNavigationItem>
    );
  };
  const getRegistrationItems = () => {
    let route = "";
    let url = undefined;
    let routeComponent = <></>;

    route = registeredListRoute;
    routeComponent = <RegistrationList />;

    return (
      <SidebarNavigationItem
        key="95"
        name={t("sidebar.finalSchoolCandidateList")}
        route={route}
        url={url}
      >
        {routeComponent}
      </SidebarNavigationItem>
    );
  };

  const getDepartmentItems = () => {
    let route = "";
    let url = undefined;
    let routeComponent = <></>;

    route = departmentListRoute;
    routeComponent = <DepartmentList />;

    return (
      <SidebarNavigationItem
        key="98"
        name={t("sidebar.departmentList")}
        route={route}
        url={url}
      >
        {routeComponent}
      </SidebarNavigationItem>
    );
  };
  const getSchoolCandidateDepartmentScheduleItems = () => {
    let route = "";
    let url = undefined;
    let routeComponent = <></>;

    route = schoolCandidateDepartmentScheduleRoute;
    routeComponent = <SchoolCandidateDepartmentSchedule />;

    return (
      <SidebarNavigationItem
        key="99"
        name={t("sidebar.schoolCandidateDepartmentScheduleList")}
        route={route}
        url={url}
      >
        {routeComponent}
      </SidebarNavigationItem>
    );
  };
  const getRequestDepartmentProgramItems = () => {
    let route = "";
    let url = undefined;
    let routeComponent = <></>;

    route = requestDepartmentProgramListRoute;
    routeComponent = <RequestDepartmentProgramList />;

    return (
      <SidebarNavigationItem
        key="98"
        name={t("sidebar.requestDepartmentProgramList")}
        route={route}
        url={url}
      >
        {routeComponent}
      </SidebarNavigationItem>
    );
  };

  return (
    <>
      <SidebarNavigationContainer
        color="primary"
        size="2"
        sidebarIsOpen={sidebarIsOpen}
        sidebarShowHamburger={false}
      >
        {/*DASHBOARS */}
        <SidebarNavigationItem
          key="15"
          name={t("sidebar.dashboard")}
          route={dashboardRoute}
          url={"/dashboard"}
        >
          <Dashboard />
        </SidebarNavigationItem>
        {/*KLJUČNI DATUMI */}
        <SidebarNavigationItem
          key="16"
          name={t("sidebar.importantDates")}
          route={schoolYearListRoute}
          url={"/school-years"}
        >
          {getImportantDatesItems()}
        </SidebarNavigationItem>
        {/*ŠKOLSKI OBVEZNICI */}
        {hasRoleAccess(SCHOOL_CANDIDATE_ACCESS) && (
          <SidebarNavigationItem
            key="17"
            name={t("sidebar.schoolCandidateList")}
            expanded={pathname.startsWith(schoolCandidateRoute) || pathname.startsWith(schoolCandidateAddressAccessRoute)}
          >
            {hasRoleAccess({
              whitelist: [
                Role.CAS,
                Role.Helpdesk,
                Role.CountyAdministrator,
                Role.CountyLeader,
              ],
            }) && [
              getSchoolCandidateItems(),
              getSchoolCandidateAddressAccessItems(),
              getSchoolCandidateInstitutionSummaryItems(),
            ]}
            {hasRoleAccess({
              whitelist: [
                Role.CAS,
                Role.Helpdesk,
                Role.InstitutionAdministrator,
                Role.InstitutionPrincipal,
                Role.Founder,
                Role.CountyAdministrator,
                Role.CountyLeader,
              ],
            }) && getSchoolCandidateInstitutionList()}
          </SidebarNavigationItem>
        )}
        {/*USTANOVE*/}
        {hasRoleAccess(INSTITUTION_ACCESS) && (
          <SidebarNavigationItem
            key="18"
            name={t("sidebar.institutions")}
            expanded={
              pathname.startsWith(institutionListRoute) ||
              pathname === houseNumberInstitutionListRoute
            }
          >
            {getInstitutionItems()}
            {hasRoleAccess({
              whitelist: [
                Role.CAS,
                Role.Helpdesk,
                Role.CountyAdministrator,
                Role.CountyLeader,
                Role.Founder,
              ],
            }) && getHouseNumberInstitutionItems()}
          </SidebarNavigationItem>
        )}
        {/*ADMINISTRACIJA*/}
        {hasRoleAccess(ADMINISTRATION_ACCESS) && (
          <SidebarNavigationItem
            key="19"
            name={t("sidebar.administration")}
            expanded={false}
          >
            {(auth.currentRole?.role === Role.CAS ||
              auth.currentRole?.role === Role.Helpdesk) &&
              getAdministrationItems()}
            <SidebarNavigationItem
              key="20"
              name={t("sidebar.usersAndRoles")}
              expanded={pathname.startsWith(userRoleRoute)}
            >
              {(auth.currentRole?.role === Role.CAS ||
                auth.currentRole?.role === Role.Helpdesk) && (
                <SidebarNavigationItem
                  key="21"
                  name={t("sidebar.roles")}
                  route={roleListRoute}
                  url={roleListMatch?.url}
                >
                  <RoleList />
                </SidebarNavigationItem>
              )}
              {getUsersRolesItems()}
            </SidebarNavigationItem>
          </SidebarNavigationItem>
        )}
        {/*STRUČNO POVJERENSTVO */}
        {hasRoleAccess(COMMITTEE_ACCESS) && (
          <SidebarNavigationItem
            key="22"
            name={t("sidebar.committeeList")}
            expanded={pathname.startsWith(committeeListRoute)}
          >
            {hasRoleAccess({
              whitelist: [
                Role.CAS,
                Role.Helpdesk,
                Role.InstitutionPrincipal,
                Role.InstitutionAdministrator,
              ],
            }) && getCommitteeItems()}
            {hasRoleAccess({
              whitelist: [
                Role.CAS,
                Role.Helpdesk,
                Role.CountyAdministrator,
                Role.CountyLeader,
              ],
            }) && [getCommitteeApprovalItems(), getCountyCommitteeItems()]}
            {hasRoleAccess({
              whitelist: [
                Role.CAS,
                Role.Helpdesk,
                Role.CountyAdministrator,
                Role.CountyLeader,
              ],
            }) && getRegionalCommitteeItems()}
            {hasRoleAccess({
              whitelist: [Role.CAS, Role.Helpdesk],
            }) && getMinistryCommitteeItems()}
          </SidebarNavigationItem>
        )}
        {/*UNOS ZAHTJEVA*/}
        {(hasRoleAccess({
          whitelist: [Role.CAS, Role.Helpdesk],
        }) ||
          (hasRoleAccess({
            whitelist: [
              Role.CountyAdministrator,
              Role.CountyLeader,
              Role.InstitutionPrincipal,
              Role.InstitutionAdministrator,
            ],
          }) &&
            (auth.currentRole?.locations?.length ?? 0) > 0)) && (
          <SidebarNavigationItem
            key="80"
            name={t("sidebar.requestList")}
            expanded={pathname.startsWith(requestListRoute)}
          >
            {getRequestItems()}
          </SidebarNavigationItem>
        )}
        {/*OBRADA ZAHTJEVA*/}
        <SidebarNavigationItem
          key="90"
          name={t("sidebar.requestAdmin")}
          expanded={pathname.startsWith(requestAdminRoute)}
        >
          {hasRoleAccess({
            blacklist: [Role.Founder],
          }) && getRequestAdminItems()}
          {hasRoleAccess({
            blacklist: [
              ...(REQUEST_ADMIN_BLACKLIST.blacklist || []),
              Role.Founder,
            ],
          }) && [
            getOutsideEnrollmentAreaItems(),
            getLanguageCourseDecisionItems(),
          ]}
          {hasRoleAccess({
            whitelist: [Role.CountyCommittee, Role.RegionalCommittee],
          }) && getLanguageCourseDecisionItems()}
          {hasRoleAccess({
            whitelist: [Role.CAS, Role.Helpdesk, Role.MinistryAdministrator],
          }) && getLanguageCourseDecisionMinistryItems()}
          {hasRoleAccess(REQUEST_ADMIN_BLACKLIST) && [
            hasRoleAccess({
              blacklist: [Role.Founder],
            }) && getRegistrationFormItems(),
            getRegistrationItems(),
          ]}
        </SidebarNavigationItem>

        {/*RASPORED PO ODJELIMA*/}
        {hasRoleAccess(ADMINISTRATION_ACCESS) && (
          <SidebarNavigationItem
            key="97"
            name={t("sidebar.departmentSchedule")}
            expanded={pathname.startsWith("/department")}
          >
            {getDepartmentItems()}
            {getSchoolCandidateDepartmentScheduleItems()}
            {getRequestDepartmentProgramItems()}
          </SidebarNavigationItem>
        )}

        {/* HIDDEN ITEMS */}
        <SidebarNavigationItem
          key="100"
          name={t("navigation.faq")}
          route={faqGroupsAndItemsRoute}
          url={"/faq"}
          hideFromMenu={true}
        >
          <Faq />
        </SidebarNavigationItem>

        <SidebarNavigationItem
          key="101"
          name={t("navigation.aboutProgram")}
          route={aboutProgramRoute}
          url={"/aboutprogram"}
          hideFromMenu={true}
        >
          <AboutProgram />
        </SidebarNavigationItem>

        <SidebarNavigationItem
          key="102"
          name={t("navigation.helpAndSupport")}
          route={helpAndSupportRoute}
          url={"/help-and-support"}
          hideFromMenu={true}
        >
          <HelpAndSupport />
        </SidebarNavigationItem>

        <SidebarNavigationItem
          key="103"
          name={"error reporting"}
          route={newErrorReporRoute}
          url={errorReportMatch?.url}
          hideFromMenu={true}
          // This opens in a new window. There doesn't appear to be
          // any way to change it :(
        >
          <ErrorReportCreate />
        </SidebarNavigationItem>

        <SidebarNavigationItem
          key="104"
          name={t("navigation.statementOfAccessibility")}
          route={statementOfAccessibilityRoute}
          url={"statement-of-accessibility"}
          hideFromMenu={true}
        >
          <StatementOfAccessibility />
        </SidebarNavigationItem>

        <SidebarNavigationItem
          key="105"
          name={t("navigation.privacyStatement")}
          route={privacyStatementRoute}
          url="/privacy-statement"
          hideFromMenu={true}
        >
          <PrivacyStatement />
        </SidebarNavigationItem>
      </SidebarNavigationContainer>
    </>
  );
}
